export default "__VITE_ASSET__923b94f7__"